<template>
  <div>
    <work-table
      :data="data"
      :loading="loading"
      @score="score"
      @showScore="showScore"
      @getData="getData"
    />
    <el-dialog
      :visible.sync="showScoreModal"
      v-if="showScoreModal"
      :width="['en', 'it', 'id'].includes($store.state.locale) ? '500px' : '380px'"
      :close-on-click-modal="false"
      center
    >
      <score-form :form="scoreForm" :type="scoreType" ref="scoreForm"/>
      <span slot="footer">
        <el-button
          type="primary"
          @click="scoreConfirm"
          size="mini"
          v-loading="btnLoadinng"
        >{{$ct('confirm')}}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="showScoreDetail"
      v-if="showScoreDetail"
      width="380px"
      :close-on-click-modal="false"
      center
    >
      <score-detail :form="scoreForm" :name="scoreName" :type="scoreType"/>
      <span slot="footer">
        <el-button type="primary" @click="showScoreDetail =false" size="mini">{{$ct('confirm')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import WorkTable from './workTable'
import ScoreForm from './scoreForm'
import cloneDeep from 'lodash-es/cloneDeep'
import ScoreDetail from './scoreDetail'
import { workScoreFilter } from '@/utils/utils'
export default {
  components: {
    WorkTable,
    ScoreForm,
    ScoreDetail
  },
  props: [
    'data',
    'loading'
  ],
  data() {
    return {
      showScoreModal: false,
      scoreForm: {},
      btnLoadinng: false,
      showScoreDetail: false,
      scoreName: '',
      scoreType: ''
    }
  },
  methods: {
    getData() {
      this.$emit('getData')
    },
    // 评分
    async score(judgeInfo) {
      if (judgeInfo.data.row.score || judgeInfo.data.row.score === 0) {
        const res = await window.API.get(`/edu/zone/work/manager/works/scores/${judgeInfo.data.row.id}`)
        if (res.status < 400) {
          this.scoreForm = res.data
          this.scoreForm.creativeScore = workScoreFilter(this.scoreForm.creative_score * 4)
          this.scoreForm.artisticScore = workScoreFilter(this.scoreForm.artistic_score * 4)
          this.scoreForm.logicalScore = workScoreFilter(this.scoreForm.logical_score * 4)
          this.scoreForm.programmingScore = workScoreFilter(this.scoreForm.programming_score * 4)
          this.showScoreModal = true
          this.scoreType = judgeInfo.type
        }
      } else {
        this.scoreForm = {
          work_name: judgeInfo.data.row.name,
          id: judgeInfo.data.row.id,
          creative_score: 0,
          artistic_score: 0,
          logical_score: 0,
          programming_score: 0
        }
        this.showScoreModal = true
        this.scoreType = judgeInfo.type
      }
    },
    // 评分确认
    async scoreConfirm() {
      const form = this.$refs.scoreForm.getForm()
      const valid = await form.validate()
      if (valid) {
        this.btnLoadinng = true
        const scoreForm = this.$refs.scoreForm.getValue()

        let pass = true
        const scoreKey = ['artisticScore', 'creativeScore', 'logicalScore', 'programmingScore']
        scoreKey.forEach((key) => {
          if (!scoreForm[key] || scoreForm[key] === 0) {
            pass = false
          }
        })
        if (!pass) {
          this.$message({
            type: 'error',
            message: this.$ct('unscored')
          })
          this.btnLoadinng = false
          return
        }
        const data = {
          artistic_score: scoreForm.artisticScore * 5,
          commentary: scoreForm.commentary,
          creative_score: scoreForm.creativeScore * 5,
          id: scoreForm.id,
          logical_score: scoreForm.logicalScore * 5,
          programming_score: scoreForm.programmingScore * 5
        }
        const res = await this.$store.dispatch('workManageScore', data)
        this.btnLoadinng = false
        if (res.status < 400) {
          this.$message({
            type: 'success',
            message: this.$ct('csuccess')
          })
          this.showScoreModal = false
          this.$emit('getData')
        }
      }
    },
    // 查看评分
    async showScore(judgeInfo) {
      let res = ''
      switch (judgeInfo.type) {
        case 'teacher':
          res = await API.get(`/edu/zone/work/manager/works/scores/${judgeInfo.data.row.id}`)
          break
        case 'student':
          res = await API.get(`/edu/zone/work/manager/works/${judgeInfo.data.row.id}/self/scores`)
          break
      }
      this.scoreForm = cloneDeep(res.data)
      this.scoreForm.score = workScoreFilter(this.scoreForm.creative_score + this.scoreForm.artistic_score + this.scoreForm.logical_score + this.scoreForm.programming_score)
      this.scoreForm.creative_score = this.scoreForm.creative_score / 5
      this.scoreForm.artistic_score = this.scoreForm.artistic_score / 5
      this.scoreForm.logical_score = this.scoreForm.logical_score / 5
      this.scoreForm.programming_score = this.scoreForm.programming_score / 5
      this.scoreName = judgeInfo.data.row.name
      this.scoreType = judgeInfo.type
      this.showScoreDetail = true
    }

  }
}
</script>
